import { createReducer, on } from '@ngrx/store';
import { IProjectScreeningStats } from '@core/state/entities/project-screening-stats/project-screening-stats.entity';
import { defaultEntityState } from '@core/state/entities/entity';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import { stageActions } from '@core/actions/stage.actions';
import {
  mergeEntityState,
  removeEntities,
  removeEntitiesByFilter,
  removeEntitiesWithIds,
} from '@core/state/entities/entity.helpers';
import { entityKey } from '@core/state/entities/entity-name-map';

export const projectScreeningStatsReducer = createReducer(
  defaultEntityState<IProjectScreeningStats>(),
  on(
    projectDetailActions.screeningSummaryReceived,
    stageActions.receivedFullStats,
    projectDetailActions.fullProjectStatsReceived,
    projectDetailActions.created,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.projectUpdated,
    projectDetailActions.projectListingUpdated,
    (state, props) =>
      mergeEntityState(entityKey.projectScreeningStats, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (projChild) => projChild.projectId === props.projectId
    )
  )
);
